export default __webpack_public_path__ + "static/media/todolist1 clone.b18c909d.png";